
function Timeline(){

    $('.block-timeline__office').on('click', function(){
        $('.block-timeline__office.is-open').not(this).find('.block-timeline__office__detail').slideUp();
        $(this).toggleClass('is-open').find('.block-timeline__office__detail').slideToggle();
    });

}